module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger_bwm-5935c11796f048cc6879b0362f6b8f84.png";